import {h} from "preact";
import {Field, Form as FinalForm} from "react-final-form"
import {FormFieldTextArea} from '../../../_common/forms/components/components'
import {fetchMessages, sendMessage} from '../../../_rx/fct/actions'
import {useParams} from 'react-router'
import {useDispatch} from 'react-redux'
import {toastService} from '../../../_services/toast-service'
import ButtonSpinner from '../../../_common/components/buttons/buttonSpinner/buttonSpinner'
import {useState} from 'preact/hooks'
import {t} from '../../../_i18n'
import {Link} from "react-router-dom";
import './fct-new-message.scss';
import UploadDocumentTimeline from "./UploadDocumenTimeline";
import AlertBox from "../../../_common/components/AlertBox/AlertBox";

export default function NewMessage({activeTab, onTabChange, showCompanySearchTab, hasUnreadGeneral, hasUnreadCompany, canSend, unreadCountCompany, unreadCountGeneral}) {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadKey, setUploadKey] = useState(0);
  const toggleTooltip = () => setVisible(prev => !prev);
  const hideTooltip = () => setVisible(false);
  const dispatch = useDispatch();
  const {id} = useParams();
  const categoryTab = activeTab === 'company_search' ? 1 : 0;

  const handleSubmit = (val) => {
    setLoading(true)
    sendMessage(id, {content: val.text, attachments: val.files.map(file => file.id), category: categoryTab })
        .then(async () => {
          await dispatch(fetchMessages(id))
            setUploadKey(prev => prev + 1);
        })
        .catch(() => {
          toastService.showToast({message: t('Ha sucedido un error al guardar el comentario'), type: 'danger'});
        })
        .finally(() => setLoading(false))
  }

  return (
      <div className="fct-message-wrapper">
        <FinalForm
            onSubmit={handleSubmit}
            initialValues={{text: '', files: []}}
            render={(formEvents) => (
                <form onSubmit={formEvents.handleSubmit} noValidate>
                    <div className='wrapper-message'>
                        <div className='fct-message-body__title font-bold m-bottom'> {t('Mensajes')} </div>
                        <div className="tabs-container">
                            <div className="inline cursor-pointer">
                                <Link to='#' className={activeTab === 'general' ? 'selected d-flex flex-center-y' : 'd-flex flex-center-y'}
                                      onClick={() => onTabChange('general')}>
                                    {t('General')}
                                    {hasUnreadGeneral && (
                                        <span className="badge-circle m-l-half">
                                            {unreadCountGeneral}
                                        </span>
                                    )}
                                </Link>
                            </div>
                            {showCompanySearchTab &&
                                <div className="inline cursor-pointer">
                                    <Link to='#' className={activeTab === 'company_search' ? 'selected d-flex flex-center-y' : 'd-flex flex-center-y'}
                                          onClick={() => onTabChange('company_search')}>
                                        {t('Búsqueda de empresa')}
                                        {hasUnreadCompany && (
                                            <span className="badge-circle m-l-half">
                                            {unreadCountCompany}
                                        </span>
                                        )}
                                    </Link>
                                </div>
                        }
                        </div>

                        {(
                            activeTab === 'general' ||
                            (activeTab === 'company_search' && (canSend || loading))
                        ) && (
                            <div className='fct-message-body'>
                                <FormFieldTextArea
                                    name='text'
                                    showOptional={false}
                                    required
                                    disabled={!canSend}
                                    specificError={t(
                                        'Por favor, antes de enviar tu comentario, asegúrate de haber escrito algún texto.'
                                    )}
                                />

                                <div className='ftp-button-bar'>
                                    <div className="wrapper-buttons">
                                        <Field
                                            key={uploadKey}
                                            name='files'
                                            label={t('Archivo')}
                                            disabled={!canSend || !formEvents.values.text?.trim()}
                                            component={UploadDocumentTimeline}
                                            contractId={id}
                                        />

                                        <div className="info-container flex-center-y">
                                          <span className="tooltip-wrapper">
                                            <i
                                                className="far fa-info-circle m-r tooltip-icon"
                                                onClick={toggleTooltip}
                                            ></i>

                                            <span
                                                className={`tooltip-content ${visible ? 'is-visible' : ''}`}
                                                onMouseLeave={hideTooltip}
                                            >
                                              {t('Los documentos aportados deben estar en formato PDF.')}
                                                <br />
                                                {t('Puedes utilizar la web')}
                                                <a
                                                    href="https://www.ilovepdf.com/es"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                &nbsp;ILOVEPDF
                                              </a>
                                                &nbsp;{t('o cualquier otra herramienta de conversión de documentos online si tu formato no coincide.')}
                                            </span>
                                          </span>
                                        </div>
                                    </div>

                                    <ButtonSpinner
                                        type='submit'
                                        showSpinner={loading}
                                        disabled={!formEvents.values.text?.trim()}
                                        className="m-t"
                                    >
                                        {t('Enviar mensaje')}
                                    </ButtonSpinner>
                                </div>
                            </div>
                        )}
                    </div>
                </form>
            )}
        />
      </div>
  )
}
